import { Box, Button, Heading, VStack, useToast } from '@chakra-ui/react';
import { AgGridReact, ICellRendererParams } from 'ag-grid-react';
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { TARM_AWS_URL } from '../../api/api';
import axios from 'axios';
import Loading from '../Loading/Loading';
import DetailedViewRenderer from './DetailedViewRenderer';
import LinkRenderer from './LinkRenderer';

const GenAIResultsGrid = () => {
  const [columnDefs] = useState([
    {
      field: "personalinformation_name",
      headerName: "Name",
      pinned: "left",
      width: 250,
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "personalinformation_email",
      headerName: "Email",
      pinned: "left",
      width: 250,
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "personalinformation_phonenumber",
      headerName: "Phone Number",
      resizable: true,
      filter: "agNumberColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "personalinformation_linkedinurl",
      headerName: "Linkedin URL",
      cellRenderer: LinkRenderer,
      resizable: true
    },
    {
      field: "personalinformation_github",
      headerName: "Github",
      cellRenderer: LinkRenderer,
      resizable: true
    },
    {
      field: "personalinformation_visainformation",
      headerName: "Visa Information",
      resizable: true
    },
    {
      field: "personalinformation_address",
      headerName: "Address",
      resizable: true,
      filter: "agTextColumnFilter",
      filterParams: {
        buttons: ["reset", "apply"],
        closeOnApply: true,
      },
    },
    {
      field: "file",
      headerName: "Detailed Views",
      resizable: false,
      cellRenderer: DetailedViewRenderer
    }
  ]);
  const [rowData, setRowData] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const [source] = useState(axios.CancelToken.source());
  const { filename } = useParams();
  const gridRef = useRef();
  const toast = useToast();

  useEffect(() => {
    getCsvJson(filename);
    return () => {
    };
  }, []);

  const getCsvJson = async (filename) => {
    try {
      const response = await TARM_AWS_URL.get(
        'get-csv-json', { params: { filename: filename } },
        {
          cancelToken: source.token,
        }
      );
      if (response.data) {
        const updatedArrayOfObj = response.data.map(obj => {
          return Object.keys(obj).reduce((acc, key) => {
            const updatedKey = key.replace(/\./g, '_');
            acc[updatedKey] = obj[key];
            return acc;
          }, {});
        });
        setRowData(updatedArrayOfObj)
      }
    } catch (error) {
      console.error(error);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <Loading loading={isLoading} />
  ) : ((
    <VStack>
      <Heading>GenAI Search Results Grid</Heading>
      <br />
      <Box textAlign="end" w="80vw"><Button size="sm">Create Pool</Button></Box>
      <div className="ag-theme-alpine" style={{ width: '80vw', height: '72vh' }}>
        <AgGridReact
          enableCellTextSelection={true}
          ref={gridRef} // Ref for accessing Grid's API
          rowData={rowData} // Row Data for Rows
          columnDefs={columnDefs} // Column Defs for Columns
        />
      </div>
    </VStack>
  ))
}

export default GenAIResultsGrid